import React from "react"
import "../../static/css/kyc.css"
import _ from "lodash";
import axios from 'axios';
// import fs from 'fs';

export default class extends React.Component {
    constructor() {
        super()
        this.state = {
            buttonState: false,
            FirstName: '',
            LastName: '',
            EmailAddress: '',
            RegCode: '',
            selectedFile: null,
            isModalOpen: false,
            message: '',
            fileName: ''
        }
    }


    handleChangeRegCode = (event) => {
        const saveValue = event.target.value;
        this.setState({
            RegCode: saveValue 
        });
        console.log(this.state.RegCode);
    }

    handleChangeFirstName = (event) => {
        const FirstName = event.target.value;
        this.setState({
            FirstName: FirstName 
        });
        console.log(this.state.FirstName);
    }

    handleChangeLastName = (event) => {
        const LastName = event.target.value;
        this.setState({
            LastName: LastName 
        });
        console.log(this.state.LastName);
    }

    handleChangeEmailAddress = (event) => {
        const EmailAddress = event.target.value;
        this.setState({
            EmailAddress: EmailAddress 
        });
        console.log(this.state.EmailAddress);
    }

    handleChangeFile = (event) => {
        const saveFile = event.target.files[0];
        this.setState({ selectedFile: event.target.files[0] });
        console.log(saveFile);
        console.log(this.state.selectedFile);
    };

    handleCloseModal = (event) => {
        this.setState({
            isModalOpen: false
        })
        window.location.reload();
    }


    // BUTTON SUBMIT IN KYC
    handleButtonSubmit = (event) => {
        event.preventDefault();

        var axios = require('axios');
        var FormData = require('form-data');

        var data = new FormData();

        var fileSize = this.state.selectedFile.size;
        var fileType = this.state.selectedFile.type;
        var fileRegcode = this.state.RegCode;
        var fileEmail = this.state.EmailAddress;

        data.append('regcode', this.state.RegCode);
        data.append('email', this.state.EmailAddress);
        data.append('file', this.state.selectedFile);
        data.append('file_location', 'kyc_video');


        // let Client = require('ssh2-sftp-client');
        // let sftp = new Client();
        // sftp.connect({
        //     Host: '210.213.236.42',
        //     Port: '3333',
        //     UN:  'v1-sftp',
        //     PW:  '0yNiXW\('
        // }).then(() => {
        //     return sftp.list('/node');
        //     // return sftp.put(buffer.data, '/path/to/new-file-name');
        //     // sftp.put('./CSV/myspreadsheet.csv', '/myspreadsheet.csv', false);  
        // console.log ("connected");
        // }).then(data => {
        //     console.log(data, 'the data info');
        // }).catch(err => {
        //     console.log(err, 'catch error');
        // });


    
        if (fileRegcode && fileEmail) {
            if (fileType == 'video/mp4') {

                const fs = require('fs');
                if (fileSize < 1e+8) {
    
                    //send to API
                    var config = {
                        method: 'post',
                        url: 'https://unified.ph/kyc-upload',
                        data : data
                    };
    
                    
                    var that = this;
                    axios(config)
                    .then(function (response) {
                        console.log(JSON.stringify(response.data))     
                        console.log(JSON.stringify(response.data.F))     
                        that.setState ({
                            fileName: response.data.F,
                        })
                        const message = "You have pending application for this transaction."
                        that.setState ({
                            message: message,
                            isModalOpen: true
                        });  
                        // console.log(that.state.fileName)
                        // var axios = require('axios');
                        // var FormData = require('form-data');
                        // var data2 = new FormData();
                        // data2.append('regcode', that.state.RegCode);
                        // data2.append('filename', that.state.fileName);
                        // data2.append('email', that.state.EmailAddress);

                        // var config2 = {
                        //     method: 'post',
                        //     url: 'http://35.185.184.154/ups_kyc_service/kyc_video',
                        //     data : data2
                        // };
                        // console.log("http")
                        
                        // axios(config2)
                        // .then(function (response) {
                        //     console.log(JSON.stringify(response.data))   
                        //     const message = "Video Successfully Uploaded."
                        //     that.setState ({
                        //         message: response.data.M,
                        //         isModalOpen: true
                        //     });  
                        // })
                        // .catch(function (error) {
                        //     console.log(error)
                        // });
    
                    })
                    .catch(function (error) {
                        console.log(error)
                    });
            
                } else {
                    console.log("file removed")
                    const message2 = "File should be lower than 100 MB."
                    this.setState ({
                        message: message2,
                        isModalOpen: true
                    });
                }
             
                fs.unlinkSync(this.state.selectedFile);

            } else {
                console.log("should be image")
                const message3 = "File should be a Video/MP4 file."
                this.setState ({
                    message: message3,
                    isModalOpen: true
                });
            }
        } else {
            console.log("should be image")
            const message4 = "Please put REGCODE and Email Address."
            this.setState ({
                message: message4,
                isModalOpen: true
            });
        }

    }


    render() {

        return(
             
            <div className="container text-center kyc" style={{marginTop:"90px",marginBottom:"100px", color: "#1F354F"}}>
            
                { this.state.isModalOpen && 
                
                <div className="modal fade show" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true" style={{display: "block", paddingTop: "10px"}}>
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="exampleModalLabel">Message</h5>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={this.handleCloseModal}>
                                <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                        <div className="modal-body">
                            {this.state.message}
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-dismiss="modal" onClick={this.handleCloseModal}>Close</button>
                        </div>
                        </div>
                    </div>
                </div>
                }

                <div className="contentpanel">
                    <div className="col-sm-12 col-md-12 col-lg-12">
                        <form>
                            <div className="card">                   
                                <img src="/static/images/UPS_Logo.png" className="image-responsive kycLogo" alt="logo"/>
                                <h3 className="labelKyc">Unified KYC</h3>
                                <div className="form-group"> 
                                    <input 
                                        type="text" 
                                        value={this.state.RegCode}
                                        onChange={this.handleChangeRegCode}
                                        className="form-control"
                                        placeholder="REGCODE"
                                        name="REGCODE"
                                        maxLength={25} 
                                        required />
                                </div>
                                <div className="form-group"> 
                                    <input 
                                        type="text" 
                                        value={this.state.FirstName} 
                                        onChange={this.handleChangeFirstName}
                                        className="form-control"
                                        placeholder="First Name"
                                        name="Name.first_name" 
                                        maxLength={25}
                                        required />
                                </div>
                                <div className="form-group"> 
                                    <input 
                                        type="text" 
                                        value={this.state.LastName} 
                                        onChange={this.handleChangeLastName}
                                        className="form-control"
                                        placeholder="Last Name"
                                        name="Name.last_name" 
                                        maxLength={25}
                                        required />
                                </div>
                                <div className="form-group"> 
                                    <input 
                                        type="email" 
                                        value={this.state.EmailAddress} 
                                        onChange={this.handleChangeEmailAddress}
                                        className="form-control"
                                        placeholder="Email Address"
                                        name="email"
                                        required />
                                </div>
                                <div className="form-group"> 
                                    <input 
                                        type="file" 
                                        value={this.state.file} 
                                        onChange={this.handleChangeFile}
                                        className="form-control"
                                        name="uploadFile"
                                        required />
                                </div>
                                <div className="form-group"> 
                                    <input 
                                        type="submit" 
                                        value="Submit" 
                                        className="form-control kycSubmitBtn"
                                        onClick={this.handleButtonSubmit}
                                        required
                                    />
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>

        )
    }
}



// WEBPACK FOOTER //
// components/kyc/Content.js